<template>
  <div v-if="markers.length" class="bottomRouge">
    <gmap-map
      class="gmapMobile"
      :center="{
        lat: markers[0].latitude,
        lng: markers[0].longitude,
      }"
      :zoom="12"
      :options="{
        mapTypeControlOptions: mapType,
      }"
      ref="map">
      <gmap-marker
        v-for="(m, index) in markers"
        :key="index"
        :clickable="true"
        :position="{
          lat: m.latitude,
          lng: m.longitude,
        }"
        @click="afficheFace(m)"
        :icon="m.icon">
      </gmap-marker>
      <gmap-marker
        v-if="markerVenteNumerique.lat"
        :position="{
          lat: markerVenteNumerique.lat,
          lng: markerVenteNumerique.lng,
        }"
        :icon="markerVenteNumerique.icon">
      </gmap-marker>
    </gmap-map>
    <app-detail-opportunites :detailFaceNumerique="detailFaceNumerique" v-if="show"/>
  </div>
</template>

<script>
import {
  MAP_TYPE_CONTROL_OPTIONS,
  STYLE_MAPS_POI_HIDDEN, MAP_TYPE_NAME,
} from '@/configurations/configurationCarto';
import filterLatLng from '@/services/general/gestionLatLng';
import detailOpportunites from './detailOpportunites';

export default {
  name: 'cartePanneauxNumerique',
  props: ['markers', 'markerVenteNumerique'],
  components: {
    appDetailOpportunites: detailOpportunites,
  },
  data() {
    return {
      moyLat: 0,
      moyLng: 0,
      centreCarte: {},
      detailFaceNumerique: {},
      show: false,
      bg: false,
      mapType: MAP_TYPE_CONTROL_OPTIONS,
      isLoadOnce: false,
    };
  },
  methods: {
    afficheFace(m) {
      this.detailFaceNumerique = m;
      this.show = true;
    },
    async levelZoom() {
      if (this.markers.length && !this.isLoadOnce) {
        const map = await this.$refs.map.$mapPromise;
        const bounds = new google.maps.LatLngBounds();
        filterLatLng(this.markers);
        this.markers.forEach(m => {
          if (m.latitude !== 0 && m.longitude !== 0
          && m.latitude !== null && m.longitude !== null) {
            bounds.extend({ lat: m.latitude, lng: m.longitude });
          }
        });
        if (this.markerVenteNumerique !== undefined && this.markerVenteNumerique.lat
          !== undefined) {
          bounds.extend({ lat: this.markerVenteNumerique.lat, lng: this.markerVenteNumerique.lng });
        }
        map.fitBounds(bounds);
        this.isLoadOnce = true;
      }
    },
  },
  async mounted() {
    const map = await this.$refs.map.$mapPromise;
    const styleMap = new google.maps.StyledMapType(STYLE_MAPS_POI_HIDDEN, {
      name: MAP_TYPE_NAME,
    });
    map.mapTypes.set('styled_map', styleMap);
    this.levelZoom();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/opportuniteClient/ismobile/propositions/panneauxNumeriques/cartePanneauxNumerique.vue